import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyYoghurtIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./YoghurtIcon-34f56cd6.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyYoghurtIcon as P };
